import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UTMdataFilter } from "../../../../helper";
import { fetchGraphUTMTerm } from "./utmTermAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  percentBooking: [],
  percentBought: [],
  weeks: [],
  labels: [],
};

export const graphUTMTerm = createAsyncThunk(
  "utmTerm/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-utm_term`;
      const response = await fetchGraphUTMTerm(dbpath, user, 'graph-utm_term');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmTermSlice = createSlice({
  name: "utmTerm",
  initialState,
  reducers: {
    resetutmTerm: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMTerm.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMTerm.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result;
          const resultData = utmTermHandler(result, "utm_term=");
          state.visitors = resultData.visitors.reverse();
          state.percentBooking = resultData.percentBooking.reverse();
          state.percentBought = resultData.percentBought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          // console.warn("UTMTerm data not found!", error)
        }

      })
      .addCase(graphUTMTerm.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetutmTerm,setUniqueEngaged} = utmTermSlice.actions;


export const SelectVisitors = (state) => state.utmTerm.visitors;
export const SelectPercentBooking = (state) => state.utmTerm.percentBooking;
export const SelectPercentBought = (state) => state.utmTerm.percentBought;
export const SelectLabels = (state) => state.utmTerm.labels;
export const SelectWeeks = (state) => state.utmTerm.weeks;
export const SelectUTMTermStatus = (state) => state.utmTerm.status;

export default utmTermSlice.reducer;

export const utmTermHandler = (data, utmParam) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    percentBooking: [],
    percentBought: [],
    labels: [],
  };

  const resultData =  UTMdataFilter(data, resultObj, utmParam);
  return resultData;
};

